module.exports = __webpack_public_path__ + "img/Van.153b2ce0.png";